<template>
	<div class="the_main">
		<router-view></router-view>
	</div>
</template>
<script>
	export default{
		name:'Main',
		data(){
			return{

			}
		},
	}
</script>
<style lang='scss' scoped>
	.the_main{
		// border: 3px solid #f00;
		flex-grow: 1;
		width: 100%;
		overflow: auto;
		padding: 20px;
		box-sizing: border-box;
		background-color: #F7F7F7;
	}
</style>